export type AgeAssurancePayload = {
  method: 'yoti' | 'videoask'
  url: string
}

export type AgeAssuranceSessionConfig =
  | {
      method: 'videoask'
    }
  | {
      method: 'yoti'
      sessionId: string
    }

export type AgeAssuranceMethod = AgeAssuranceSessionConfig['method']

export type AgeAssuranceSessionOutcome = 'success' | 'fail'

type AgeAssuranceSessionBase = {
  nullifiedAt?: string
  startedAt: string
  config: AgeAssuranceSessionConfig
}

export type AgeAssuranceSessionPending = AgeAssuranceSessionBase & {
  status: 'pending'
}

export enum YotiMethod {
  AgeEstimation = 'age_estimation',
  DocScan = 'doc_scan',
}

export type AgeAssuranceSessionCompleted = AgeAssuranceSessionBase & {
  status: 'completed'
  completedAt: string
  outcome: AgeAssuranceSessionOutcome
  yotiMethod?: YotiMethod
}

export type AgeAssuranceSessionAborted = AgeAssuranceSessionBase & {
  status: 'aborted'
  abortedAt: string
}

export type AgeAssuranceSession =
  | AgeAssuranceSessionPending
  | AgeAssuranceSessionCompleted
  | AgeAssuranceSessionAborted

export type AgeAssuranceHistory = AgeAssuranceSession[]
